module.exports = __webpack_public_path__ + "img/Unova2.c8d13240.png";